<template>
  <div>
    <div class="columns onboarding-policies-view--main">
      <div v-if="isStandAloneTreatment" class="column is-8" test-id="treatmentPolicies">
        <h4>48‑hour Reschedule Notice</h4>
        <p>Need to skip a mow? Have to reschedule? No problem!</p>
        <p>
          If you do not cancel or reschedule a service date already scheduled at least 48 hours
          prior to such date, you will be charged the full amount for the canceled or rescheduled
          service.
        </p>
      </div>
      <div v-else class="column is-8" test-id="mowingPolicies">
        <h4>Long Grass Policy</h4>
        <p v-for="(paragraph, index) in longGrassPolicy" :key="index">{{ paragraph }}</p>

        <h4>3-cut Minimum</h4>
        <p>
          We're so confident that you'll enjoy our service that, unlike most lawn care companies, we
          don't require you to sign a long term contract. In fact, we only ask that you commit to
          three cuts in order to evaluate the service.
        </p>
        <p>
          If you're not pleased with the work being done, simply contact us by phone, email, or app,
          and we'll be more than happy to address your concerns.
        </p>
        <h4>48‑hour Reschedule Notice</h4>
        <p>Need to skip a mow? Have to reschedule? No problem!</p>
        <p>
          Go ahead and skip or reschedule a service, for free, with at least 48 hours notice. Any
          less time than that, and you'll be billed for the cost of your normal cut.
        </p>
      </div>
    </div>
    <div class="columns">
      <div class="column">
        <LsButton
          text="agree &amp; continue"
          track-id="onboarding_policies_view-agree_and_continue"
          class="onboarding-policies-view--agree"
          :loading="onboarding.loadingStatus.isUpdating"
          :disabled="onboarding.loadingStatus.isRemoving"
          @click="syncOrder"
        />
        <LsButton
          text="disagree"
          bg-color="primary-light"
          text-color="primary"
          track-id="onboarding_policies_view-disagree"
          :disabled="onboarding.loadingStatus.isRemoving || onboarding.loadingStatus.isUpdating"
          @click="openCancelOrderModal"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex';
import { LsButton } from '@/components/common';
import { ONBOARDING__SYNC_ORDER, AUTH__PROCESSING_ORDER } from '@/store/types';
import moment from 'moment';
import { lsModalService } from 'ls-vue-common';
import { serviceType, lsLongGrassHelpers } from '@/helpers';

import { CancelOrderModal } from '@/modals';

export default {
  name: 'OnboardingPoliciesView',
  components: {
    LsButton,
  },
  computed: {
    ...mapGetters([AUTH__PROCESSING_ORDER]),
    ...mapState(['onboarding', 'featureFlags']),
    isStandAloneTreatment() {
      const intent = this[AUTH__PROCESSING_ORDER].type;
      return intent === serviceType.TREATMENT;
    },
    longGrassPolicy() {
      return lsLongGrassHelpers.getLongGrassPolicy();
    },
  },
  methods: {
    ...mapActions([ONBOARDING__SYNC_ORDER]),
    async syncOrder() {
      this[ONBOARDING__SYNC_ORDER]({
        policies_accepted_at: moment().format('YYYY-MM-DD HH:mm:ss'),
      });
    },
    openCancelOrderModal() {
      lsModalService.open({
        parent: this,
        component: CancelOrderModal,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.onboarding-policies-view--main {
  border-bottom: 1px solid $primary-light;
  margin-bottom: 20px;
  h4 {
    margin-bottom: 15px;
  }
  p {
    margin-bottom: 25px;
  }
}

.onboarding-policies-view--agree {
  margin-bottom: 10px;
}

@media (min-width: $desktop) {
  .onboarding-policies-view--agree {
    margin-right: 10px;
  }
}
.themed-app {
  .onboarding-policies-view--main {
    border-color: $theme-color-primary-light;
  }
}
</style>
